/**
 * option数据用于页面各种选择类, 以及表格中数字转义
 * 新增时请确保key没有重复
 * 使用时通过this.$opt[key]访问数据
 */
import GLOBAL from '@l/constant.js';
import i18n from '@/i18n/index.js';

const options = () => ({
  /**
   * 转换对应的字符串
   * @param {String/Number} index 索引(有可能是数字)
   * @param {Array/Function}} array 获取要循环数组
   * @param {String} value 要比对的key
   * @param {String} label 要返回的标签
   */
  switchStr: function (index, array, value, label) {
    if (index === '' || index === undefined) return;
    let result = '';
    let itemArray = array;
    for (let i = 0; i < itemArray.length; i++) {
      let item = itemArray[i];
      if (index == item[value || 'value']) {
        result = item[label || 'label'];
        break;
      }
    }
    return result;
  },
  // 请求类型
  requestType: [
    // 普通请求
    {
      label: i18n.t('HT.options.requestType1'),
      value: 1
    },
    // 注册请求(双向通信)
    {
      label: i18n.t('HT.options.requestType2'),
      value: 2
    },
    // 注销请求(双向通信)
    {
      label: i18n.t('HT.options.requestType3'),
      value: 3
    },
    // 下行通知请求(双向通信)
    {
      label: i18n.t('HT.options.requestType4'),
      value: 4
    }
  ],
  agreement: [
    // 协议
    {
      label: 'http',
      value: 'http'
    },
    {
      label: 'https',
      value: 'https'
    }
  ],
  httpMethod: [
    // http请求方式
    {
      label: 'GET',
      value: 'GET'
    },
    {
      label: 'POST',
      value: 'POST'
    },
    {
      label: 'PATCH',
      value: 'PATCH'
    },
    {
      label: 'PUT',
      value: 'PUT'
    },
    {
      label: 'DELETE',
      value: 'DELETE'
    },
    {
      label: 'HEAD',
      value: 'HEAD'
    },
    {
      label: 'OPTIONS',
      value: 'OPTIONS'
    },
    {
      label: 'TRACE',
      value: 'TRACE'
    },
    {
      label: 'ANY',
      value: 'ANY'
    }
  ],
  // 入参请求模式
  accessMode: [
    // 仅映射入参（校验全部入参）
    {
      label: i18n.t('HT.options.accessMode1'),
      value: 'ONLY_MAPPING'
    },
    // 映射并透传（校验映射入参）
    {
      label: i18n.t('HT.options.accessMode2'),
      value: 'PASS_THROUGH_MAPPING'
    },
    // 透传（无任何校验）
    {
      label: i18n.t('HT.options.accessMode3'),
      value: 'PASS_THROUGH'
    }
  ],
  parameter: [
    // 参数位置
    {
      label: 'Path',
      value: 'Path'
    },
    {
      label: 'Query',
      value: 'Query'
    },
    {
      label: 'Header',
      value: 'Header'
    },
    {
      label: 'Body',
      value: 'Body'
    }
  ],
  dataType: [
    // 数据类型
    {
      label: 'String',
      value: 'String'
    },
    {
      label: 'Int',
      value: 'Int'
    },
    {
      label: 'Double',
      value: 'Double'
    },
    {
      label: 'Bool',
      value: 'Bool'
    },
    {
      label: 'Array',
      value: 'Array'
    },
    {
      label: 'Long',
      value: 'Long'
    }
  ],
  serviceType: [
    // 服务类型
    {
      label: 'HTTP',
      value: 'HTTP'
    },
    {
      label: 'MOCK',
      value: 'MOCK'
    }
  ],
  contentType: [
    // 内容类型
    {
      label: 'ALL',
      value: 'ALL'
    },
    {
      label: 'APPLICATION_JSON_UTF8',
      value: 'APPLICATION_JSON_UTF8'
    },
    {
      label: 'TEXT_PLAIN',
      value: 'TEXT_PLAIN'
    },
    {
      label: 'APPLICATION_OCTET_STREAM',
      value: 'APPLICATION_OCTET_STREAM'
    },
    {
      label: 'APPLICATION_XML',
      value: 'APPLICATION_XML'
    },
    {
      label: 'TEXT_HTML',
      value: 'TEXT_HTML'
    }
  ],
  // 插件类型
  pluginType: [
    // 流量控制
    {
      label: i18n.t('HT.options.pluginType1'),
      value: 1
    },
    // IP访问控制
    {
      label: i18n.t('HT.options.pluginType2'),
      value: 2
    },
    // 后端签名
    {
      label: i18n.t('HT.options.pluginType3'),
      value: 3
    },
    // JWT鉴权
    {
      label: i18n.t('HT.options.pluginType4'),
      value: 4
    },
    // 跨域资源访问
    {
      label: i18n.t('HT.options.pluginType5'),
      value: 5
    },
    // 缓存
    {
      label: i18n.t('HT.options.pluginType6'),
      value: 6
    },
    // 后端路由
    {
      label: i18n.t('HT.options.pluginType7'),
      value: 7
    },
    // 参数访问控制
    {
      label: i18n.t('HT.options.pluginType8'),
      value: 8
    },
    // 错误码映射
    {
      label: i18n.t('HT.options.pluginType9'),
      value: 9
    },
    // 断路器(仅专享实例)
    {
      label: i18n.t('HT.options.pluginType10'),
      value: 10
    },
    // OAuth2
    {
      label: i18n.t('HT.options.pluginType11'),
      value: 11
    }
  ],
  configMode: [
    // 配置模式
    {
      label: i18n.t('HT.options.configMode1'),
      value: 1
    },
    {
      label: i18n.t('HT.options.configMode2'),
      value: 2
    }
  ],
  env: [
    // 环境
    {
      label: i18n.t('HT.options.env1'),
      value: 'ANY'
    },
    {
      label: i18n.t('HT.options.env2'),
      value: 'TEST'
    },
    {
      label: i18n.t('HT.options.env3'),
      value: 'PRE'
    },
    {
      label: i18n.t('HT.options.env4'),
      value: 'RELEASE'
    }
  ],

  env2: [
    // 环境
    {
      label: i18n.t('HT.options.env2'),
      value: 'TEST'
    },
    {
      label: i18n.t('HT.options.env3'),
      value: 'PRE'
    },
    {
      label: i18n.t('HT.options.env4'),
      value: 'RELEASE'
    }
  ],

  quota: [
    // 环境
    {
      label: i18n.t('HT.options.quota1'),
      value: 'USED'
    },
    {
      label: i18n.t('HT.options.quota2'),
      value: 'MOSTVALUE'
    },
    {
      label: i18n.t('HT.options.quota3'),
      value: 'RET'
    },
    {
      label: i18n.t('HT.options.quota4'),
      value: 'MOSTLIMIT'
    }
  ],
  accessType: [
    {
      label: i18n.t('HT.options.accessType1'),
      value: 'ALLOW'
    },
    {
      label: i18n.t('HT.options.accessType2'),
      value: 'DENY'
    }
  ],
  unit: [
    {
      label: i18n.t('HT.options.unit1'),
      value: 'SECONDS'
    },
    {
      label: i18n.t('HT.options.unit2'),
      value: 'MINUTES'
    },
    {
      label: i18n.t('HT.options.unit3'),
      value: 'HOURS'
    },
    {
      label: i18n.t('HT.options.unit4'),
      value: 'DAYS'
    }
  ],
  userType: [
    {
      label: i18n.t('HT.options.userType1'),
      value: 'FRONT'
    },
    {
      label: i18n.t('HT.options.userType2'),
      value: 'BACK'
    }
  ],
  safeList: [
    //安全认证分组
    {
      label: i18n.t('HT.options.safeList1'),
      value: 'NONE'
    },
    {
      label: i18n.t('HT.options.safeList2'),
      value: 'APP'
    },
    {
      label: i18n.t('HT.options.safeList3'),
      value: 'OPEN_ID'
    },
    {
      label: i18n.t('HT.options.safeList4'),
      value: 'APP_AND_OPEN_ID'
    }
  ],
  debugSafeList: [
    //安全认证分组
    {
      label: i18n.t('HT.options.debugSafeList1'),
      value: 'NONE'
    },
    {
      label: i18n.t('HT.options.debugSafeList2'),
      value: 'EASY'
    }
  ],
  apiList: [
    //API类型分组
    {
      label: i18n.t('HT.options.apiList1'),
      value: 'AUTH'
    },
    {
      label: i18n.t('HT.options.apiList2'),
      value: 'BUSINESS'
    }
  ],
  codeList: [
    //API类型分组
    {
      label: i18n.t('HT.options.codeList1'),
      value: 'FORBID'
    },
    {
      label: i18n.t('HT.options.codeList2'),
      value: 'HEADER'
    },
    {
      label: i18n.t('HT.options.codeList3'),
      value: 'HEADER_AND_QUERY'
    }
  ],
  paramsList: [
    //参数签名认证分组
    {
      label: 'HmacSHA256',
      value: 'HmacSHA256'
    }
  ],
  bodyList: [
    //body类型分组
    {
      label: 'FORM',
      value: 'FORM'
    },
    {
      label: 'JSON',
      value: 'JSON'
    }
  ],
  fixCodeList: [
    //固定参数名称
    {
      label: 'JM_G_gate_id',
      value: 'JM_G_gate_id'
    },
    {
      label: 'JM_G_request_id',
      value: 'JM_G_request_id'
    },
    {
      label: 'JM_G_app_key',
      value: 'JM_G_app_key'
    },
    {
      label: 'JM_G_app_id',
      value: 'JM_G_app_id'
    }
  ],
  codePositionList: [
    //参数位置
    // {
    //     label: 'Path',
    //     value: 'Path'
    // },
    {
      label: 'Header',
      value: 'Header'
    },
    {
      label: 'Query',
      value: 'Query'
    }
    // {
    //     label: 'Body',
    //     value: 'Body'
    // },
  ],
  productType: [
    //产品类型
    {
      label: i18n.t('HT.options.productType1'),
      value: 'INTERFACE_SERVICE'
    },
    {
      label: i18n.t('HT.options.productType2'),
      value: 'EQUIPMENT_SERVICE'
    },
    {
      label: i18n.t('HT.options.productType3'),
      value: 'LOG_SERVICE'
    },
    {
      label: i18n.t('HT.lbs.correlation'),
      value: 'LBS_SERVICE'
    },
    {
      label: i18n.t('HT.face.correlation'),
      value: 'FACE_SERVICE'
    },
    {
      label: i18n.t('HT.Nordic.name'),
      value: 'NORDIC_SERVICE'
    }
  ],
  productTypes: [
    //产品类型
    {
      label: i18n.t('HT.options.productType1'),
      value: 'INTERFACE_SERVICE'
    },
    {
      label: i18n.t('HT.lbs.correlation'),
      value: 'LBS_SERVICE'
    },
    {
      label: i18n.t('HT.face.correlation'),
      value: 'FACE_SERVICE'
    },
    {
      label: i18n.t('HT.Nordic.name'),
      value: 'NORDIC_SERVICE'
    }
  ],
  http_status: [
    //http状态码
    {
      label: '200',
      value: '200'
    },
    {
      label: '400',
      value: '400'
    },
    {
      label: '401',
      value: '401'
    },
    {
      label: '402',
      value: '402'
    },
    {
      label: '403',
      value: '403'
    },
    {
      label: '404',
      value: '404'
    },
    {
      label: '405',
      value: '405'
    },
    {
      label: '500',
      value: '500'
    }
  ],
  expire_date: [
    // 有效期
    {
      label: '1' + i18n.t('HT.options.unit5'),
      value: 1
    },
    {
      label: '3' + i18n.t('HT.options.unit5'),
      value: 3
    },
    {
      label: '5' + i18n.t('HT.options.unit5'),
      value: 5
    },
    {
      label: '100' + i18n.t('HT.options.unit5'),
      value: 100
    },
    {
      label: i18n.t('HT.custom'),
      value: 0
    }
  ],
  approvalStatus: [

    // 审批状态
    {
      label: i18n.t('HT.options.approvalStatus1'),
      value: '0'
    },
    {
      label: i18n.t('HT.options.approvalStatus2'),
      value: '1'
    },
    {
      label: i18n.t('HT.options.approvalStatus3'),
      value: '2'
    }
  ],
  productStatus: [
    // 上架状态
    {
      label: i18n.t('HT.options.productStatus1'),
      value: '0'
    },
    {
      label: i18n.t('HT.options.productStatus2'),
      value: '1'
    },
    {
      label: i18n.t('HT.options.productStatus3'),
      value: '2'
    }
  ],
  approval: [
    // 审批
    {
      label: i18n.t('HT.options.approval1'),
      value: '1'
    },
    {
      label: i18n.t('HT.options.approval2'),
      value: '2'
    }
  ],
  SmsStatus: [
    // 短信审核状态
    {
      label: i18n.t('HT.options.productStatus2'),
      value: 0
    },
    {
      label: i18n.t('HT.options.productStatus3'),
      value: 1
    }
  ],
  messageType: [
    //消息类型
    {
      label: i18n.t('HT.options.messageType1'),
      value: 'NOTIFICATION'
    },
    {
      label: i18n.t('HT.options.messageType2'),
      value: 'VERIFICATION_CODE'
    },
    {
      label: i18n.t('HT.options.messageType3'),
      value: 'VOICE_TTS'
    }
  ],
  channelType: [
    {
      label: i18n.t('HT.options.channelType1'),
      value: 1
    },
    {
      label: i18n.t('HT.options.messageType3'),
      value: 2
    }
  ],
  channelStatus: [
    {
      label: i18n.t('HT.options.channelStatus1'),
      value: false
    },
    {
      label: i18n.t('HT.options.channelStatus2'),
      value: true
    }
  ],
  tempType: [
    {
      label: i18n.t('HT.options.tempType1'),
      value: 0
    },
    {
      label: i18n.t('HT.options.tempType2'),
      value: 1
    },
    {
      label: i18n.t('HT.options.messageType3'),
      value: 2
    }
  ],
  seriesType: [
    {
      label: i18n.t('HT.options.seriesType1'),
      value: GLOBAL.YESTERDAY
    },
    {
      label: i18n.t('HT.options.seriesType2'),
      value: GLOBAL.SEVEN
    },
    {
      label: i18n.t('HT.options.seriesType3'),
      value: GLOBAL.THIRTY
    },
    {
      label: i18n.t('HT.options.seriesType4'),
      value: GLOBAL.YEAR
    }
  ],
  // 规则计费方式
  ruleType: [{ label: i18n.t('HT.options.ruleType1'), value: 0 }],
  // 订单状态
  orderStatus: [
    { label: i18n.t('HT.options.orderStatus1'), value: '' },
    { label: i18n.t('HT.options.orderStatus2'), value: 0 },
    { label: i18n.t('HT.options.orderStatus3'), value: 1 },
    { label: i18n.t('HT.options.orderStatus4'), value: 4 }
  ],
  // 支付方式
  payType: [
    { label: i18n.t('HT.options.orderStatus1'), value: '' },
    { label: i18n.t('HT.options.payType1'), value: 0 },
    { label: i18n.t('HT.options.payType2'), value: 1 },
    { label: i18n.t('HT.options.payType3'), value: 2 }
  ],
  // 国际化翻译类型
  langKeyType: [
    { label: i18n.t('HT.options.frontEnd'), value: '1' },
    { label: i18n.t('HT.options.afterEnd'), value: '2' },
  ],
  // 国际化翻译场景
  langKeyScene: [
    { label: i18n.t('HT.options.console'), value: '1' },
    { label: i18n.t('HT.options.official'), value: '2' },
  ],
  //服务状态
  serviceStatus:[
    {label:i18n.t('HT.advancedService.status.inEffect'),value:1},
    {label:i18n.t('HT.advancedService.status.pending'),value:2},
    {label:i18n.t('HT.advancedService.status.completed'),value:3},
  ],
  //类型类型
  positionType:[
    {label:i18n.t('HT.advancedService.positionType.wifi'),value:2},
    {label:i18n.t('HT.advancedService.positionType.lbs'),value:4},
  ]
});

export default options;
